/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.providers'},
});

const ProvidersItem = () => (
  <RouteLinkItem
    route="midas/settings/health/providers"
    title={messages.title}
  />
);

export default ProvidersItem;
